/* ODAVIA unified market selector — sets country_code + locale_code together and
   submits the native {% form 'localization' %} in one action. No currency faking. */
(function(){
  if (customElements.get('odavia-market')) return;
  class OdaviaMarket extends HTMLElement {
    connectedCallback(){
      this.form = this.closest('form');
      this.toggle = this.querySelector('[data-odavia-market-toggle]');
      this.panel = this.querySelector('[data-odavia-market-panel]');
      this.overlay = this.querySelector('[data-odavia-market-overlay]');
      this.countryInput = this.parentNode.querySelector('[data-odavia-country-input]') || (this.form && this.form.querySelector('input[name="country_code"]'));
      this.localeInput = this.parentNode.querySelector('[data-odavia-locale-input]') || (this.form && this.form.querySelector('input[name="locale_code"]'));
      if (!this.toggle || !this.panel) return;
      this.toggle.addEventListener('click', this.onToggle.bind(this));
      this.querySelectorAll('[data-country]').forEach((a)=> a.addEventListener('click', this.onSelect.bind(this)));
      if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
      document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape') this.close(); });
      document.addEventListener('click', (e)=>{ if (this.isOpen() && !this.contains(e.target)) this.close(); });
    }
    isOpen(){ return this.toggle.getAttribute('aria-expanded') === 'true'; }
    onToggle(e){ e.preventDefault(); e.stopPropagation(); this.isOpen() ? this.close() : this.open(); }
    open(){
      this.toggle.setAttribute('aria-expanded','true');
      this.panel.hidden = false;
      if (this.overlay) this.overlay.hidden = false;
      this.classList.add('is-open');
      document.body.classList.add('odavia-market-open');
    }
    close(){
      if (!this.isOpen()) return;
      this.toggle.setAttribute('aria-expanded','false');
      this.panel.hidden = true;
      if (this.overlay) this.overlay.hidden = true;
      this.classList.remove('is-open');
      document.body.classList.remove('odavia-market-open');
    }
    onSelect(e){
      e.preventDefault();
      var row = e.currentTarget;
      var country = row.getAttribute('data-country');
      var locale = row.getAttribute('data-locale');
      if (this.countryInput && country) this.countryInput.value = country;
      if (this.localeInput && locale) this.localeInput.value = locale;
      // native submit → Shopify sets market + language + currency, keeps return_to path
      if (this.form) this.form.submit();
    }
  }
  customElements.define('odavia-market', OdaviaMarket);
})();
